/**
 * @author Akshay Kumar Singh
 * @file Pagination Component
 * @flow
 */
import React from 'react';
import Paginate from '@material-ui/lab/Pagination';


/**
 * @description This functional component paginates the data according to the value of its parameters.
 * @param dataPerPage It has count of data to be shown on each page.
 * @param currentPage It has value of current page number.
 * @param totalData It has total count of data.
 * @param paginate It is the callback function to paginate data of exact page number.
 * @param firstPage It has the value of first page.
 * @param paginateFirstPage It is the callback function to paginate data of first page.
 * @param lastPage It has the value of last page.
 * @param paginateLastPage It is the callback function to paginate data of last page.
 * @param pageIncrement It is the callback function to increment page.
 * @param pageDecrement It is the callback function to decrement page.
 */
const Pagination = (props) => {

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(props.totalData / props.dataPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageClick = (event, value) => {
    event.preventDefault();
    props.paginate(value)
  }

  return (
    <nav className='pagination-nav'>
      <div className='pagination'>
        <Paginate count={pageNumbers.length} defaultPage={props.firstPage} siblingCount={1}
          boundaryCount={1} onChange={handlePageClick} variant="outlined" color="primary"
          showFirstButton showLastButton hidePrevButton={false} hideNextButton={false} />
        {/* <ul>
          <li className={currentPage === firstPage ? 'disable arrow-pager' : ' arrow-pager'}><a onClick={(event) => paginateFirstPage(event, 1)} href=''>«</a></li>
          <li className={currentPage === firstPage ? 'disable arrow-pager' : 'arrow-pager'}><a onClick={(event) => pageDecrement(event)} href=''>‹</a></li>
          {pageNumbers.map(number => (
            <li key={number} className={currentPage === number ? 'active' : ''}>
              <a onClick={(event) => paginate(event, number)} href=''>{number}</a>
            </li>
          ))}
          <li className={currentPage === lastPage ? 'disable arrow-pager' : 'arrow-pager'}><a onClick={(event) => pageIncrement(event)} href=''>›</a></li>
          <li className={currentPage === lastPage ? 'disable arrow-pager' : 'arrow-pager'}><a onClick={(event) => paginateLastPage(event, 1)} href=''>»</a></li>
        </ul> */}
      </div>
    </nav>
  );
};

export default Pagination;